import {
    Theme,
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
} from '@mui/material';

declare module '@mui/material/Avatar' {
    interface AvatarPropsVariantOverrides {
        roundedSmall: true;
        roundedMedium: true;
        roundedLarge: true;

        rounded: false;
    }
}

interface M3Avatar {
    MuiAvatar: {
        defaultProps?: ComponentsProps['MuiAvatar'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiAvatar'];
        variants?: ComponentsVariants['MuiAvatar'];
    };
}

export const getAvatar = (theme: Theme): M3Avatar => {
    return {
        MuiAvatar: {
            variants: [
                {
                    props: { variant: 'roundedSmall' },
                    style: { borderRadius: 8 },
                },
                {
                    props: { variant: 'roundedMedium' },
                    style: { borderRadius: 16 },
                },
                {
                    props: { variant: 'roundedLarge' },
                    style: { borderRadius: 28 },
                },
            ],
        },
    };
};
